import React, { useEffect, useState, useRef } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import './style.scss';

const STATUS_MAP = {
  NORMAL: 'normal',
  MOVING: 'moving',
  STATIC: 'static',
};

// 三种border的状态,渐变色转动,渐变色静止,正常
const ColorContainer = props => {
  const {
    children,
    className,
    moveTime,
    active,
    animation,
    dataId,
    dataTools,
    dataStatus,
    ...rest
  } = props;
  const [borderStatus, setBorderStatus] = useState('normal');

  useEffect(() => {
    if (animation) {
      setBorderStatus(STATUS_MAP.MOVING);
    } else if (active) {
      setBorderStatus(STATUS_MAP.STATIC);
    } else {
      setBorderStatus(STATUS_MAP.NORMAL);
    }
  }, [active, animation]);

  const angle = useMotionValue(0);

  // 生成动态的conic-gradient样式
  const borderImage = useTransform(angle, value => {
    const colors = [
      '#9B4CFF',
      '#DC6BFF',
      '#FFA16A',
      '#E0FF7D',
      '#82FF96',
      '#40FFE4',
      '#4750FC',
      '#9B4CFF',
    ];
    const borderImage = `conic-gradient(from ${value}deg, ${colors.join(',  ')}) 1`;
    return borderImage;
  });

  const backgroundImage = useTransform(angle, value => {
    const colors = [
      '#9B4CFF',
      '#DC6BFF',
      '#FFA16A',
      '#E0FF7D',
      '#82FF96',
      '#40FFE4',
      '#4750FC',
      '#9B4CFF',
    ];
    const backgroundImage = `conic-gradient(from ${value}deg, ${colors.join(',  ')})`;
    return backgroundImage;
  });

  // 启动无限旋转动画
  useEffect(() => {
    let controls = null;
    if (borderStatus === STATUS_MAP.MOVING) {
      controls = animate(angle, 360, {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
      });
    }

    return () => {
      if (controls) {
        controls.stop();
      }
    };
  }, [borderStatus]);

  return (
    <section
      className={`border-container ${borderStatus}-container ${className}`}
      data-id={dataId}
      data-tools={dataTools}
      data-status={dataStatus}
      {...rest}
    >
      {/* 彩色动画边框 */}
      <motion.div
        className={`moving-border-outline ${borderStatus !== STATUS_MAP.MOVING ? '!opacity-0' : ''}`}
        style={{
          background: backgroundImage,
        }}
      />
      {React.cloneElement(children, { ...rest })}
      {/* 彩色动画边框内发光 */}
      <motion.div
        className={`moving-border-shadow ${borderStatus !== STATUS_MAP.MOVING ? '!opacity-0' : ''}`}
        style={{
          borderImage: borderImage,
        }}
      ></motion.div>
    </section>
  );
};

export default ColorContainer;
